import React, { useEffect } from "react";
import FormBuilder from "../components/FormBuilder/FormBuilder";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSingleTemplate,
  setSelectedTemplateNull,
} from "../redux/entities/formBuilderEntity";
import useModalStrip from "../global-hooks/useModalStrip";

const FormBuilderPage = () => {
  const template = useAppSelector(
    (state) => state.entities.formBuilder.selectedTemplate
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { showModalStrip } = useModalStrip();
  const { formId } = useParams();

  useEffect(() => {
    if (!formId) return; // Avoid unnecessary calls if `formId` is undefined.

    const fetchTemplate = async () => {
      try {
        const template = await dispatch(
          getSingleTemplate(formId)
        ).unwrap();

        if (!template) {
          throw new Error("Not found");
        }
      } catch (ex) {
        showModalStrip("danger", "The form id is not correct", 5000);
        navigate("/");
      }
    };

    fetchTemplate();

    return () => {
      // Reset the selected template when the component unmounts.
      dispatch(setSelectedTemplateNull());
    };
  }, [dispatch, formId]); // Optimized dependency array

  const defaultForm = {
    id: "0",
    formName: "",
    createdAt: 0,
    creator: "",
    formLayoutComponents: [],
    lastPublishedAt: 0,
    publishHistory: [],
    publishStatus: "draft",
    updatedAt: 0,
  };

  return template ? (
    <FormBuilder template={template} />
  ) : null;
};

export default FormBuilderPage;
